const { Criteria } = Shopware.Data;

export default {
    template: `
<sw-page class="riccardo-loyalty-list">
    <template #search-bar>
        <sw-search-bar initial-search-type="riccardo_loyalty_account" placeholder="Kartennummer, Name oder E-Mail suchen" :initial-search="term" @search="onSearch" />
    </template>
    <template #smart-bar-header><h2>Kundenkarten <span v-if="!isLoading">({{ total }})</span></h2></template>
    <template #smart-bar-actions>
        <sw-button variant="primary" :is-loading="isCreating" @click="createCard">Karte ohne Konto ausgeben</sw-button>
    </template>
    <template #content>
        <sw-entity-listing v-if="accounts" :items="accounts" :repository="accountRepository" :columns="columns" :is-loading="isLoading" :show-selection="false" :allow-inline-edit="false" detail-route="riccardo.loyalty.detail" @page-change="onPageChange">
            <template #column-cardNumber="{ item }">
                <router-link :to="{ name: 'riccardo.loyalty.detail', params: { id: item.id } }" style="font-variant-numeric: tabular-nums;">{{ formatCard(item.cardNumber) }}</router-link>
            </template>
            <template #column-customer="{ item }">
                <span v-if="item.customer">{{ item.customer.firstName }} {{ item.customer.lastName }} <small style="color:#798490">{{ item.customer.email }}</small></span>
                <span v-else style="color:#798490">– ohne Kundenkonto –</span>
            </template>
            <template #column-pointsBalance="{ item }"><strong>{{ item.pointsBalance.toLocaleString('de-DE') }}</strong></template>
            <template #column-pointsPending="{ item }">{{ item.pointsPending.toLocaleString('de-DE') }}</template>
            <template #column-active="{ item }">
                <sw-icon :name="item.active ? 'regular-checkmark-xs' : 'regular-times-s'" :color="item.active ? '#37d046' : '#de294c'" small />
            </template>
        </sw-entity-listing>
    </template>
</sw-page>`,

    inject: ['repositoryFactory', 'loginService'],

    mixins: [Shopware.Mixin.getByName('notification')],

    data() {
        return { accounts: null, isLoading: false, isCreating: false, total: 0, page: 1, limit: 25, term: '' };
    },

    computed: {
        accountRepository() {
            return this.repositoryFactory.create('riccardo_loyalty_account');
        },
        columns() {
            return [
                { property: 'cardNumber', label: 'Kartennummer', primary: true },
                { property: 'customer', label: 'Kunde', sortable: false },
                { property: 'pointsBalance', label: 'Punktestand', align: 'right' },
                { property: 'pointsPending', label: 'Vorgemerkt', align: 'right' },
                { property: 'active', label: 'Aktiv', align: 'center', width: '80px' },
            ];
        },
    },

    created() {
        this.getList();
    },

    methods: {
        formatCard(number) {
            return (number || '').replace(/(\d{4})(?=\d)/g, '$1 ');
        },

        onSearch(term) {
            this.term = term || '';
            this.page = 1;
            this.getList();
        },

        onPageChange({ page, limit }) {
            this.page = page;
            this.limit = limit;
            this.getList();
        },

        getList() {
            this.isLoading = true;
            const criteria = new Criteria(this.page, this.limit);
            criteria.addAssociation('customer');
            criteria.addSorting(Criteria.sort('createdAt', 'DESC'));
            criteria.setTotalCountMode(1);
            if (this.term) {
                const digits = this.term.replace(/\s+/g, '');
                criteria.addFilter(Criteria.multi('OR', [
                    Criteria.contains('cardNumber', digits),
                    Criteria.contains('customer.lastName', this.term),
                    Criteria.contains('customer.firstName', this.term),
                    Criteria.contains('customer.email', this.term),
                    Criteria.contains('customer.customerNumber', this.term),
                ]));
            }
            return this.accountRepository.search(criteria).then((result) => {
                this.accounts = result;
                this.total = result.total;
            }).finally(() => { this.isLoading = false; });
        },

        createCard() {
            this.isCreating = true;
            const httpClient = Shopware.Application.getContainer('init').httpClient;
            return httpClient.post('_action/riccardo-loyalty/card', { note: 'Im Admin ausgegeben' }, {
                headers: { Authorization: `Bearer ${this.loginService.getToken()}` },
            }).then(({ data }) => {
                this.createNotificationSuccess({ message: `Karte ${this.formatCard(data.cardNumber)} angelegt` });
                this.$router.push({ name: 'riccardo.loyalty.detail', params: { id: data.accountId } });
            }).finally(() => { this.isCreating = false; });
        },
    },
};
